module.exports = __webpack_public_path__ + "static/media/employees.d2af59f5.svg";